import axios from 'axios';
import { useQuery } from 'react-query';
import * as yup from 'yup';
import { reportSchema } from '~/schemas/reportSchema';
const responseSchema = yup
    .object()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup
        .object({
        reports: yup.array().of(reportSchema).ensure(),
    })
        .required(),
});
async function fetchPreviousPatientReports(patientId) {
    const response = await axios.get(`/api/report/patient/list/${patientId}`);
    const { data: { reports }, } = await responseSchema.validate(response.data);
    return reports;
}
export function usePreviousPatientReportsQuery(patientId, enabled) {
    return useQuery(['previous_patient_reports', patientId], function () {
        return fetchPreviousPatientReports(patientId);
    }, {
        enabled,
    });
}
